import {
  FALLBACK_LOCALE,
  SUPPORTED_LOCALES,
  htmlLang,
  isLocale,
} from "@holigral/shared/i18n"

type HeadLink = { rel: string; href: string; hrefLang?: string }

/**
 * The canonical link for a page, plus, on locale-prefixed public pages
 * (/{locale}/…), the hreflang alternates, so search engines pair the language
 * versions. `origin` is the site's public origin, e.g. https://profiling.app.
 */
export default function localeHeadLinks(origin: string, pathname: string) {
  const links: HeadLink[] = [{ rel: "canonical", href: `${origin}${pathname}` }]

  const [, segment = "", rest = ""] = /^\/([^/]+)(\/.*)?$/.exec(pathname) ?? []
  if (isLocale(segment)) {
    for (const locale of SUPPORTED_LOCALES) {
      links.push({
        rel: "alternate",
        hrefLang: htmlLang(locale),
        href: `${origin}/${locale}${rest}`,
      })
    }
    links.push({
      rel: "alternate",
      hrefLang: "x-default",
      href: `${origin}/${FALLBACK_LOCALE}${rest}`,
    })
  }

  return links
}
